//
//
//
//

export default {
    name: 'MainHeaderTitleOnly',
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
